// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__FRJ+8","welcome":"Landing_welcome__C+h85","pragmate":"Landing_pragmate__g3Ecv","slogan":"Landing_slogan__NgSc9"};